import { render, staticRenderFns } from "./DialogoExpandir.vue?vue&type=template&id=7234793c&scoped=true"
import script from "./DialogoExpandir.vue?vue&type=script&lang=js"
export * from "./DialogoExpandir.vue?vue&type=script&lang=js"
import style0 from "./DialogoExpandir.vue?vue&type=style&index=0&id=7234793c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7234793c",
  null
  
)

export default component.exports